module.exports = __webpack_public_path__ + "img/allow_pets.8932aa1c.svg";